module.exports = __webpack_public_path__ + "media/images/vp/samples/14-90b32f63d46b628043d924bc7ad7f5eb.jpg";